<template>
	<div class="Leadercare">
		<div class="Leadercare-top">
			<img
				:src="require('@/assets/images/leadercare-top.png')"
				class="image-width"
				alt=""
			/>
		</div>
		<div class="Leadercare-mid-out">
			<div class="Leadercare-mid">
				<img
					:src="require('@/assets/images/leadercare-care.png')"
					class="image-width"
					alt=""
				/>
			</div>
			<div class="Leadercare-mid-text">{{ $t('领导关怀') }}</div>
		</div>
		<div class="Leadercare-con">
			<div
				class="Leadercare-con-item"
				v-for="(item, index) in Imglist"
				:key="index"
				@click="Lookdetail(index)"
			>
				<img :src="item.url" class="image-width" alt="" />
			</div>
		</div>
	</div>
</template>

<script>
import { ImagePreview } from 'vant';
import { getLeaderDetailImageList, getLeaderImageList } from '@/api';
export default {
	data() {
		return {
			Imglist: []
		};
	},
	created() {
		this.frontListFZ();
	},
	methods: {
		//查看图片详情
		Lookdetail(index) {
			let images = [];
			this.Imglist.forEach(item => {
				images.push(item.url);
			});
			ImagePreview({
				images: images,
				startPosition: index
			});
		},
		//业务图片接口
		frontListFZ() {
			let params = {
				type: 1,
				language: Number(this.lang === 'en')
			};
			getLeaderImageList(params).then(res => {
				let id = res.list[0].id;
				this.imageListFZ(id);
			});
		},
		//业务图片详情接口
		imageListFZ(id) {
			getLeaderDetailImageList(id).then(res => {
				this.Imglist = res.list;
			});
		}
	}
};
</script>

<style lang="scss">
@use './Leadercare.scss';
</style>
